import { defineRecipe } from '@plurall/elo-v3';

import { themeCardGridBase } from '@/features/themes/lib/recipes/themeCardGrid.recipe';

export const learningPathsListPageGridRecipe = defineRecipe({
  className: 'learning-paths-list-page__grid',
  base: themeCardGridBase,
});

export const learningPathsListPageStateRecipe = defineRecipe({
  className: 'learning-paths-list-page__state',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.8',
    textAlign: 'center',
    color: 'text.secondary',
    paddingBlock: '3rem',
  },
});

export const learningPathsListPagePaginationRecipe = defineRecipe({
  className: 'learning-paths-list-page__pagination',
  base: {
    display: 'flex',
    justifyContent: 'center',
    marginBlockStart: 'space.24',
  },
});
